import React from 'react';
import { Link } from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';

import {
  Button,
} from '@material-ui/core';

import BasicInfo from './BasicInfo';
import ProfileIntro from './ProfileIntro';
import PersonalInfo from './PersonalInfo';
import LifestyleInfo from './LifestyleInfo';
import EducationInfo from './EducationInfo';
import FamilyInfo from './FamilyInfo';
import ContactInfo from './ContactInfo';
import ReferenceInfo from './ReferenceInfo';
import ProfilePhotos from './ProfilePhotos';
import ProfilePDFs from './ProfilePDFs';
import PartnerChoice from './PartnerChoice';
import ProfileQuickSummary from './ProfileQuickSummary';

import * as routes from '../../config/routes';
import classes from '../../css/getCSS';


const displayProfile = (props) => {
  return (
    <React.Fragment>
      <ProfileIntro {...props} />
      <br />
      <ProfilePhotos {...props} />
      <br />
      <ProfileQuickSummary {...props} />
      <br />
      <ProfilePDFs {...props} />
      <br />
      {props.profile.is_editable
        ? <React.Fragment><BasicInfo {...props} /><br /></React.Fragment>
        : null}
      <PersonalInfo {...props} />
      <br />
      <LifestyleInfo {...props} />
      <br />
      <EducationInfo {...props} />
      <br />
      <FamilyInfo {...props} />
      <br />
      <ContactInfo {...props} />
      <br />
      {props.profile.is_editable
        ? <React.Fragment><ReferenceInfo {...props} /><br /></React.Fragment>
        : null}
      {props.profile.partnerchoice
        ? <PartnerChoice {...props} /> : null}
      <br />
      {props.profile.is_editable
        ? (
          <Link
            to={formatRoute(routes.DELETE_PROFILE)}
            className={classes.linkDeCSS}
          >
            <Button variant="outlined" className={classes.dangerButton}>Delete Profile</Button>
          </Link>
        ) : null}
    </React.Fragment>
  );
};

export default displayProfile;



// WEBPACK FOOTER //
// ./src/profile/components/DisplayProfile.js